// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {Text} from 'sail/Text';
import DataTable, {DataTableBody} from 'sail/DataTable';
import type {VideoModel} from 'docs/data';
import {PlaylistVideoSelectorRow} from './PlaylistVideoSelectorRow';

import './PlaylistVideoSelector.scss';

type PlaylistVideoSelectorProps = {|
  prefVideos: Array<VideoModel>,
  currentVideo: VideoModel,
  onChangeVideo: (video: VideoModel) => any,
|};

export const PlaylistVideoSelector = ({
  prefVideos,
  onChangeVideo,
  currentVideo,
}: PlaylistVideoSelectorProps) => {
  return (
    <Box style={{height: 550}}>
      <Text
        display="block"
        align="left"
        style={{paddingBottom: 6}}
        size={16}
        weight="bold"
        lineHeight={28}
      >
        {prefVideos.length} Tutorials
      </Text>
      <Box style={{height: 400, overflow: 'scroll'}}>
        <DataTable>
          <DataTableBody>
            {prefVideos.map((video, i) => (
              <PlaylistVideoSelectorRow
                key={i}
                index={i}
                video={video}
                onChangeVideo={onChangeVideo}
                selectedVideo={currentVideo}
              />
            ))}
          </DataTableBody>
        </DataTable>
      </Box>
    </Box>
  );
};
